import React from "react";

function Principle() {
  return (
    <div className="md:row-span-2 bg-green-100 rounded-2xl overflow-hidden drop-shadow-lg ">
      <div
        id="carouselExampleInterval "
        className="carousel slide h-full "
        data-bs-ride="carousel"
      >
        <div className="carousel-inner h-full w-full mb-4">
          <div
            className="carousel-item active bg-red-600 h-full text-justify md:px-10 px-4 ease-in-out"
            data-bs-interval="4000"
          >
            <div className="bg-amber-400 p-1 w-28 rounded-full text-sm text-white font-bold flex justify-evenly my-3 md:my-3">
              ⏱️PRINCIPLES
            </div>
            <h1 className="font-bold uppercase text-white text-2xl md:text-4xl py-3 tracking-wide md:tracking-normal ">
              Ethics always come first.
            </h1>
            <p className="text-slate-200 text-lg tracking-wider pb-1 md:text-xl">
              I consciously practice being real and ethical and choose to work
              with people who share the same values
            </p>
          </div>
          <div className="carousel-item bg-amber-500 h-full text-justify px-4 ease-in-out" data-bs-interval="4000">
            <div className="bg-red-600 p-1 w-28 rounded-full text-sm text-white font-bold flex justify-evenly my-3 md:my-3">
              ⏱️PRINCIPLES
            </div>
            <h1 className="font-bold uppercase text-white text-2xl md:text-4xl py-2 tracking-tighter md:tracking-normal">
              Internal World over External World.
            </h1>
            <p className="text-slate-200 text-lg  tracking-normal pb-1 md:text-xl">
              I value happiness, health and strong relationships over material success and mere professional networking.
            </p>
          </div>
          <div className="carousel-item  bg-blue-700 px-4 text-justify h-full ease-in-out">
            <div className="bg-red-600 p-1 w-28 rounded-full text-sm text-white font-bold flex justify-evenly my-3 md:my-3">
              ⏱️PRINCIPLES
            </div>
            <h1 className="font-bold uppercase text-white text-2xl md:text-4xl py-3 tracking-wide md:tracking-normal">
              Details, a lot of Details.
            </h1>
            <p className="text-slate-200 text-lg tracking-wider md:text-xl">
              I feel really fullfilled when I am allowed to add in really fine
              details to my workwith genuine interest & emotion.
            </p>
          </div>
        </div>
        <button
          className="carousel-control-prev "
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon visually-hidden"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next "
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon visually-hidden"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default Principle;
